
import { formatText } from '../lib/utils';
import { motion } from 'framer-motion';

const WhyUs = () => {
    return (
        <motion.section
            id="why-us"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex flex-col border-b-[1px] border-[#525252] md:pb-[6rem] sm:pb-[5rem] pb-[5rem] lg:pb-[120px] md:pt-[6rem] sm:pt-[5rem] pt-[5rem] lg:pt-[120px] xl:w-[100%] xl:max-w-[auto] w-[100%] max-w-[auto] ml-[auto] mr-[auto]"
        >
            <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] 2xl:max-w-[1536px]">
                <div className="flex flex-col gap-[2rem] sm:gap-[3rem] w-[100%] sm:w-[60%]">
                    <h2 className="text-[36px] sm:text-[48px] font-semibold block leading-[1.25em] sm:leading-none">{formatText("Dlaczego my?")}</h2>

                    <p className="text-[18px] text-[#a3a3a3] opacity-[100%] leading-[1.6em]">
                        {formatText("Od 10 lat pomagam firmom tworzyć reklamy, które zwiększają konwersje na Meta Ads oraz Google Ads! Dzięki doświadczeniu mogę realnie pomóc Twojemu biznesowi.")}
                    </p>

                    <ul className="flex flex-col gap-4 mt-2">
                        {[
                            "10 lat doświadczenia",
                            "Szybkość wykonywania usługi",
                            "Doradztwo marketingowe",
                            "Atrakcyjne ceny i zniżki w przypadku pakietów"
                        ].map((item, index) => (
                            <li key={index} className="flex items-center gap-3 text-[18px] text-[#a3a3a3]">
                                <span className="w-1.5 h-1.5 rounded-full bg-white block"></span>
                                {formatText(item)}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </motion.section>
    );
};

export default WhyUs;
